import { TERRITORIES } from 'common/constants/territories';

export interface IConfig {
  serviceName: string;
  authCheckTimeout: number;
  authClientId: string;
  getAuthHeaders: (token: string) => Partial<{ Authorization: string }>;
  e100SiteLink: string;
  authServiceName: string;
  clientSiteLink: string;
  clientRussianRailwaysLink: string;
  routeStationsDistance: number;
  mapId: string;
  autonomyDomain: string;
  appStage: string;
  googleAppKey: string;
  yandexAppKey: string;
  map: number;
  territory: number;
  appState: string;
}

const {
  serviceName,
  authServiceName,
  authCheckTimeout,
  authClientId,
  clientSiteLink,
  clientRussianRailwaysLink,
  e100SiteLink,
  routeStationsDistance,
  mapId,
  autonomyDomain,
  appStage,
  googleAppKey,
  yandexAppKey,
  map = 2,
  territory = TERRITORIES.east,
  appState,
} = window.fuelStationsLocator || {};

const config: IConfig = {
  serviceName,
  authServiceName,
  authCheckTimeout,
  authClientId,
  clientSiteLink,
  clientRussianRailwaysLink,
  e100SiteLink,
  routeStationsDistance,
  mapId,
  autonomyDomain,
  appStage,
  googleAppKey,
  yandexAppKey,
  map,
  territory,
  appState,
  getAuthHeaders: (token) => (token ? { Authorization: token } : {}),
};

export default config;
